import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'adminConsole.customerService.title',
    defaultMessage: 'Console supporto clienti',
    description: 'Title of the Customer service page',
  },
  breadcrumbClientSupport: {
    id: 'adminConsole.customerService.breadcrumb',
    defaultMessage: 'Supporto clienti',
    description: 'Breadcrumb of the Customer service page',
  },
  widgetTitle: {
    id: 'adminConsole.customerService.widgetTitle',
    defaultMessage: 'Ricerca cliente',
    description: 'Title of the widget',
  },
  resultsSectionTitle: {
    id: 'adminConsole.customerService.resultsSectionTitle',
    defaultMessage: 'Risultati ricerca cliente',
    description:
      'Title of the subsection where the search results are displayed',
  },
  ownerNameInputLabel: {
    id: 'adminConsole.customerService.ownerNameInputLabel',
    defaultMessage: 'Nome',
    description: 'Label for owner input field',
  },
  ownerNameInputPlaceholder: {
    id: 'adminConsole.customerService.ownerNameInputPlaceholder',
    defaultMessage: 'Nome',
    description: 'Placeholder for owner input field',
  },
  ownerSurnameInputLabel: {
    id: 'adminConsole.customerService.ownerSurnameInputLabel',
    defaultMessage: 'Cognome',
    description: 'Label for owner input field',
  },
  ownerSurnameInputPlaceholder: {
    id: 'adminConsole.customerService.ownerSurnameInputPlaceholder',
    defaultMessage: 'Cognome',
    description: 'Placeholder for owner input field',
  },
  ragioneSocialeInputLabel: {
    id: 'adminConsole.customerService.ragioneSocialeInputLabel',
    defaultMessage: 'Ragione sociale',
    description: 'Label for Ragione sociale input field',
  },
  ragioneSocialeInputPlaceholder: {
    id: 'adminConsole.customerService.ragioneSocialeInputPlaceholder',
    defaultMessage: 'Ragione sociale',
    description: 'Placeholder for Ragione sociale input field',
  },
  customerCodeInputLabel: {
    id: 'adminConsole.customerService.customerCodeInputLabel',
    defaultMessage: 'Codice cliente',
    description: 'Label for Customer code input field',
  },
  customerCodeInputPlaceholder: {
    id: 'adminConsole.customerService.customerCodeInputPlaceholder',
    defaultMessage: 'Codice cliente',
    description: 'Placeholder for Customer code input field',
  },
  statusSelectLabel: {
    id: 'adminConsole.customerService.statusSelectLabel',
    defaultMessage: 'Stato',
    description: 'Label for Status select field',
  },
  statusSelectActiveOption: {
    id: 'adminConsole.customerService.statusSelectActiveOption',
    defaultMessage: 'Attivo',
    description: 'Label for active option of status select',
  },
  statusSelectBlockedOption: {
    id: 'adminConsole.customerService.statusSelectBlockedOption',
    defaultMessage: 'Bloccato',
    description: 'Label for blocked option of status select',
  },
  errorInvalidFieldFormat: {
    id: 'adminConsole.customerService.errorInvalidFieldFormat',
    defaultMessage: 'Inserisci almeno 3 caratteri',
    description: 'Error title for field format not valid',
  },
  credentialRecoveryProcedureSent: {
    id: 'adminConsole.credentialRecovery.credentialRecoveryProcedureSent',
    defaultMessage:
      'Procedura recupero {type} inviata correttamente via {channel}',
    description:
      'Dialog message to notify that the procedure to recovery credential has been sent',
  },
  userUnlock: {
    id: 'adminConsole.credentialRecovery.userUnlock',
    defaultMessage: "L'utenza è stata sbloccata",
    description: 'Dialog message to notify that the user has been unlocked',
  },
  errorNotMigratedUser: {
    id: 'common.errorNotMigratedUserWeb',
    defaultMessage:
      'Per effettuare il recupera password è necessario che il cliente effettui il primo accesso al MyAzimut',
    description: 'Error description for not migrated user web side',
  },
  cleanFilters: {
    id: 'adminConsole.customerService.cleanFilters',
    defaultMessage: 'Pulisci filtri',
    description: 'Label for clean filters button',
  },
});
